import * as actionTypes from "./actionTypes";
import {
  getNineBoxSettingsAPI,
  orderNineBoxSettingsAPI,
  updateNineBoxSettingsAPI,
} from "@icarius-connection/api";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import { getLocalizedString, getErrorStringFromServerError } from "@icarius-localization/strings";

const errorHandler = (e, dispatch, type) => {
  let errorString = "";

  switch (e.response?.data?.status) {
    case "INVALID_DATA":
    case "VALIDATION_ERROR":
      errorString = getLocalizedString("validationError");
      break;
    default:
      errorString = getErrorStringFromServerError(e);
      break;
  }
  dispatch(openSnackbarAction({ msg: errorString, severity: "error" }));
}

export const getNineBoxSettingsAction = (type) => async (dispatch) => {
  dispatch({ type: actionTypes.GET });
  try {
    let response = await getNineBoxSettingsAPI();

    let data = response.data && response.data.data;
    let status = response.data && response.data.status;

    if (status !== "OK") {
      dispatch({ type: actionTypes.GET_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.GET_FULFILLED,
      payload: { data },
    });
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.GET_REJECTED, payload: e });
    errorHandler(e, dispatch, type);
  }
};

export const modifyNineBoxSettingsAction = (dataToSend, type) => async (dispatch) => {
  dispatch({ type: actionTypes.MODIFY });
  try {
    let response = await updateNineBoxSettingsAPI(dataToSend);

    let data = response.data && response.data.data;
    let status = response.data && response.data.status;

    if (status !== "OK") {
      dispatch({ type: actionTypes.MODIFY_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.MODIFY_FULFILLED,
      payload: { data },
    });

    dispatch(openSnackbarAction({
      msg: getLocalizedString("quadrantSuccesfullyUpdated"),
      severity: "success"
    }));
    return response;
  } catch (e) {
    errorHandler(e, dispatch, type);
    dispatch({ type: actionTypes.MODIFY_REJECTED, payload: e });
  }
};

export const orderNineBoxSettingsAction = (dataToSend, type) => async (dispatch) => {
  dispatch({ type: actionTypes.MODIFY });
  try {
    let response = await orderNineBoxSettingsAPI(dataToSend);

    let data = response.data && response.data.data;
    let status = response.data && response.data.status;

    if (status !== "OK") {
      dispatch({ type: actionTypes.MODIFY_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.MODIFY_FULFILLED,
      payload: { data },
    });

    dispatch(openSnackbarAction({
      msg: getLocalizedString("updatedQuadrantOrderSuccessfully"),
      severity: "success"
    }));
    return response;
  } catch (e) {
    errorHandler(e, dispatch, type);
    dispatch({ type: actionTypes.MODIFY_REJECTED, payload: e });
  }
};